import { render, staticRenderFns } from "./PcEditor.vue?vue&type=template&id=5cf8b298&"
import script from "./PcEditor.vue?vue&type=script&lang=js&"
export * from "./PcEditor.vue?vue&type=script&lang=js&"
import style0 from "./PcEditor.vue?vue&type=style&index=0&id=5cf8b298&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports